import React from "react";
import { motion } from "framer-motion";
import { Leaf, Snowflake, Flower2, Sun, Trophy, Shield, Crown, Repeat } from "lucide-react";
import { PREMIUM_BG_URL, SOCCER_BALL_URL } from "../lib/config";

const LEAGUES = [
  { id: "autumn", name: "Autumn League", desc: "Mini-campionato autunnale", icon: Leaf, color: "#F59E0B", span: "md:col-span-2" },
  { id: "winter", name: "Winter League", desc: "Sfida invernale", icon: Snowflake, color: "#60A5FA", span: "md:col-span-1" },
  { id: "spring", name: "Spring League", desc: "Rinascita primaverile", icon: Flower2, color: "#A78BFA", span: "md:col-span-1" },
  { id: "summer", name: "Summer League", desc: "Sfida estiva di chiusura stagione", icon: Sun, color: "#FB923C", span: "md:col-span-2" },
  { id: "champions", name: "Champions League", desc: "Il torneo a scontri diretti", icon: Trophy, color: "#00E5FF", span: "md:col-span-2" },
  { id: "winter_champ", name: "Campione d'Inverno", desc: "Vincitore del girone d'andata", icon: Crown, color: "#FBBF24", span: "md:col-span-1" },
  { id: "highlander1", name: "Highlander 1", desc: "Ne resterà soltanto uno", icon: Shield, color: "#EF4444", span: "md:col-span-1" },
  { id: "highlander2", name: "Highlander 2", desc: "Seconda sfida a eliminazione", icon: Shield, color: "#EC4899", span: "md:col-span-1" },
  { id: "return", name: "Fanta Partenope Return", desc: "La rivincita di stagione", icon: Repeat, color: "#10B981", span: "md:col-span-2" },
];

export default function SideLeagues() {
  return (
    <section id="leghe" className="relative py-24 md:py-32 px-5 md:px-8 overflow-hidden" data-testid="leagues-section">
      <div
        className="absolute inset-0 bg-cover bg-center opacity-20"
        style={{ backgroundImage: `url(${PREMIUM_BG_URL})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-fp-bg via-fp-bg/80 to-fp-bg" />
      <div className="relative max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-16 gap-5">
          <div>
            <div className="text-xs tracking-[0.4em] uppercase text-fp-cyan font-heading font-semibold">
              9 Competizioni in parallelo
            </div>
            <h2 className="mt-4 font-heading font-black text-4xl md:text-5xl lg:text-6xl tracking-tight silver-gradient max-w-3xl">
              Più occasioni di <span className="cyan-gradient">vincere</span>
            </h2>
          </div>
          <p className="text-white/60 max-w-md text-sm md:text-base">
            Ogni iscritto partecipa automaticamente a tutte le leghe collaterali. Nessun costo aggiuntivo.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {LEAGUES.map((l, i) => {
            const Icon = l.icon;
            return (
              <motion.div
                key={l.id}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ delay: i * 0.07, duration: 0.5 }}
                className={`${l.span} group relative p-7 md:p-8 rounded-3xl border border-white/10 bg-fp-surface/60 backdrop-blur-sm hover:-translate-y-1 hover:border-fp-cyan/50 transition-all duration-500 overflow-hidden min-h-[200px]`}
                data-testid={`league-${l.id}`}
              >
                <div
                  className="absolute -right-8 -top-8 w-40 h-40 rounded-full blur-3xl opacity-20 group-hover:opacity-40 transition-opacity"
                  style={{ background: l.color }}
                />
                <div className="relative flex items-start justify-between">
                  <div
                    className="w-12 h-12 rounded-2xl flex items-center justify-center border"
                    style={{
                      background: `${l.color}15`,
                      borderColor: `${l.color}40`,
                      color: l.color,
                    }}
                  >
                    <Icon size={22} />
                  </div>
                  <span className="text-[10px] tracking-[0.3em] uppercase text-white/40 font-heading font-semibold">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                </div>
                <h3 className="relative mt-6 font-heading font-bold text-2xl md:text-3xl tracking-tight text-white">
                  {l.name}
                </h3>
                <p className="relative mt-2 text-white/60 text-sm">{l.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
